import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg" }, /*#__PURE__*/_toDisplayString("Item"), -1)
const _hoisted_3 = {
  id: "btn-action-add",
  class: "flex justify-end"
}
const _hoisted_4 = { class: "flex justify-between items-center gap-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "w-full flex flex-col gap-2" }
const _hoisted_7 = {
  id: "actions",
  class: "flex justify-end items-center gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TipTap = _resolveComponent("TipTap")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
    class: "flex flex-col gap-5 pt-5 border-t"
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("labels.generic", {
          pt: "Crie textos com lacunas e utilize @ para adicionar e definir quais palavras devem ser colocadas em cada espaço em branco.",
          en: "Create texts with gaps and use @ to add and define which words must be put on each blank space",
        })), 1),
    _hoisted_2,
    (_ctx.tipTapIsReady)
      ? (_openBlock(), _createBlock(_component_TipTap, {
          key: 0,
          questionStoreType: "dragAndDrop"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.gaps?.length !== 2)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: _ctx.$t('labels.generic', { pt: 'Adicionar lacuna', en: 'Add gap' }),
            icon: "pi pi-plus",
            class: "btn-simple w-fit",
            onClick: _withModifiers(_ctx.addGap, ["prevent"])
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gaps, (input, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("i", {
            id: "remove-gap-action",
            class: "pi pi-minus mt-6 bg-h-warning-700 rounded-full p-1 text-white cursor-pointer hover:scale-90 transition-all mb-5",
            onClick: _withModifiers(($event: any) => (_ctx.removeGap(index)), ["prevent"])
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Resposta da lacuna ",
                en: "Response for gap",
              }) +
              (index + 1)), 1),
            _createVNode(_component_InputText, {
              modelValue: input.name,
              "onUpdate:modelValue": ($event: any) => ((input.name) = $event),
              maxLength: 200,
              class: _normalizeClass([
              {
                'p-invalid':
                  _ctx.questionStore.v$Dialog?.gaps.$dirty &&
                  _ctx.questionStore.v$Dialog.gaps.$each.$response.$data[index].name
                    .$invalid,
              },
            ])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: 
              _ctx.questionStore.v$Dialog?.gaps.$dirty
                ? _ctx.questionStore.v$Dialog.gaps.$each.$response?.$errors[index]
                    ?.name
                : []
            ,
              actualLength: input.name.length,
              maxLength: 200
            }, null, 8, ["errors", "actualLength"])
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Button, {
        label: "Cancelar",
        class: "btn-outline",
        onClick: _withModifiers(_ctx.onClose, ["prevent"])
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Confirmar",
        class: "btn-primary",
        type: "submit"
      })
    ])
  ], 32))
}